import React from 'react';
import './NotFound.module.css';

function NotFound() {
    return (
        <div className="not-found-container">
            <h1 className="not-found-title">Oops! Pagina nu a fost găsită.</h1>
            <p className="not-found-message">Ne pare rău, dar adresa URL pe care ai încercat să o accesezi nu există.</p>
            {/* Poți adăuga aici un link pentru a reveni la pagina principală */}
            <a href="/" className="not-found-link">Înapoi la pagina principală</a>
        </div>
    );
}

export default NotFound;